import React from 'react'
import { ChatBreakoutSquare, MessageChatCircle, MessageSmileCircle, Zap } from '../../../icons'

const HowCards = ({ icon, title, detail }) => {
    return (
        <div className="flex flex-col gap-[20px] w-full max-sm:items-center">
            <div className="flex items-center justify-center p-[8px] rounded-full bg-[#A4D6B4] w-fit">
                <div className="flex items-center justify-center p-[8px]  rounded-full bg-[#1C9943]">
                    {icon}
                </div>
            </div>
            <div className="flex flex-col gap-[8px]">
                <span className='text-[#101828] text-[20px] font-bold max-sm:text-center'>
                    {title}
                </span>
                <p className='text-[16px] text-[#475467] max-sm:text-center'>
                    {detail}
                </p>
            </div>
        </div>
    )
}
 
const HowSection = () => {
    return (
        <div className='py-[96px] flex flex-col gap-[64px] px-[5.8vw] w-ful overflow-hidden max-w-[1980px] w-full'>
            <div className="flex flex-col gap-[20px] max-w-[768px] max-lg:flex-col max-lg:text-center">
                <div className="flex flex-col gap-[12px]">
                    <span className='text-[#1C9943] font-bold'>
                        How to be Healthy
                    </span>
                    <h2 className='text-[36px] font-bold text-[#101828]'>
                        The Truth is if You Think Your Body is Full of Fat.
                    </h2>
                </div>
                <p className='text-[20px] text-[#475467]'>
                    Powerful, self-serve product and growth analytics to help you convert, engage, and retain more users. Trusted by over 4,000 startups.
                </p>
            </div>
            <div className="flex items-center justify-between gap-[64px] max-lg:flex-col">
                <div className="grid sm:grid-cols-2 grid-cols-1 gap-[32px] w-full">
                    <HowCards
                        icon={<MessageChatCircle  iconColor={'#FFF'}/>}
                        title={'Achieve More in Less Time With Us'}
                        detail={'Transform your to-do list into a ‘to-achieve’ list with quick, effective workouts that deliver results without the wait..'}
                    />
                    <HowCards
                        icon={<Zap iconColor={'#FFF'}  />}
                        title={'Beyond Quick Fixes in Fitness'}
                        detail={'Escape the cycle of fleeting fitness fads with our proven approach to lasting weight loss and wellness.'}
                    />
                    <HowCards
                        icon={<ChatBreakoutSquare iconColor={'#FFF'} />}
                        title={'A Journey to Joyful Vitality at Any Age'}
                        detail={'Rediscover your zest for life and reclaim a toned, vibrant self—no matter if you’re in your 30s, 40s, or 50s.'}
                    />
                    <HowCards
                        icon={<MessageSmileCircle iconColor={'#FFF'} />}
                        title={'Embrace Your Shape: Fashion Beyond the Bumps'}
                        detail={'Join countless others overcoming the belly bulge and embracing fashion that celebrates, not conceals'}
                    />
                </div>
                <div className="relative w-full sm:min-h-[660px] min-h-[340px]">
                    <img src="/images/handArrow.png" className='absolute z-[1] left-[20%] top-[-120px] handAnime' alt="" />
                    <img src="/images/howImage.png" className='absolute left-0 max-w-none w-[136%] top-0' alt="" />
                </div>
            </div>
        </div>
    )
} 

export default HowSection;